export default __webpack_public_path__ + "static/media/card-m-product.6611532c.png";